import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Cameroonian() {
  return (
    <ApiCommunityDirectoryPage
      community="Cameroonian"
      eyebrow="Cameroonian community guide"
      title="Cameroonian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Cameroonian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Cameroonian community guide?"
      modalIdPrefix="cameroonian-directory"
    />
  );
}
